/* esm.sh - applesauce-core@5.2.0/helpers/hidden-tags */
export * from "/*applesauce-core@5.2.0/esnext/helpers/hidden-tags.mjs";
